import React, { useCallback, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL COMPONENTS
import Card from 'parts/card/Card.js';

// LOCAL VARIABLES
import { MODEL_NAME_CODE_OPTIONS, TRIM_SELECTION_OPTIONS } from '../options.js'

// LOCAL COMPONENTS
import RebateTrims from './RebateTrims.js';

// LOCAL FUNCTIONS
import { validateUnique } from './schema.js';

// VARIABLES
const ITEM_CONSTRUCTOR = () => ({
  model_text: undefined,
  trim_selection: undefined,
  trims: []
})

// MAIN COMPONENT
const RebateModels = () => {

  // FORMIK
  const {
    values,
    values: {
      model_selection,
      model_name_code
    },
    setFieldValue
  } = useFormikContext() || {};

  const validationSchema = useMemo(() => {
    return validateUnique(values.rebate_models, 'model_text', 'Model Names should be Unique')
  }, [values.rebate_models])

  //MEMOs
  const hasModels = useMemo(
    () => parseInt(model_selection) === 1,
    [model_selection]
  )
  const addModels = useMemo(
    () => parseInt(model_name_code) === 0 || parseInt(model_name_code) === 1,
    [model_name_code]
  )
  const useName = useMemo(
    () => parseInt(model_name_code) === 0,
    [model_name_code]
  )

  // CALLBACKS
  const handleChange = useCallback(
    () => {
      setFieldValue('rebate_models', []);
    },
    [setFieldValue]
  )

  // RENDER
  return !hasModels ? null : (<>
    <Form.Checklist
      type="radio"
      name="model_name_code"
      label="Model or Model Code"
      options={MODEL_NAME_CODE_OPTIONS}
      onChange={handleChange}
      required
      useCSV
    />
    {!addModels ? null : (<>
      <Card.Divider />
      <Form.Table
        name="rebate_models"
        title="Enter Model(s)*"
        itemLabel="Model"
        itemConstructor={ITEM_CONSTRUCTOR}
        min={1}
      >{(item = {}) => useName ? [
        <Form.Control
          name="model_text"
          label="Model Name"
          required
          colWidth={8}
          validationSchema={validationSchema}
        />,
        <Form.Checklist
          type="radio"
          name="trim_selection"
          label="Trim Selection"
          options={TRIM_SELECTION_OPTIONS}
          required
          useCSV
          colWidth={8}
        />,
        <RebateTrims
          show={String(item.trim_selection) === '1'}
          name="trims"
          colWidth={8}
        />
      ] : [
        <Form.Control
          name="model_text"
          label="Model Code"
          colWidth={8}
        />
      ]}</Form.Table>
      <Card.Divider />
    </>)}
  </>)
}

// EXPORT
export default RebateModels